import React from 'react';
import '../css/chip.sass';

interface ChipProps {
  text: string;
  id: string;
  style?: {};
}

export default function Chip(props: ChipProps) {
  const { text, style } = props;

  return (
    <span className="chip" style={style}>
      {text}
    </span>
  );
}
